import { useState, useEffect } from 'react';
import PayPalPaymentService from '../services/PayPalPaymentService.js';
import { QueryStatus } from '../types-internal/QueryStatus.js';

const usePayPalUserIdToken = (siteId, userId, isCustomerRegistered) => {
    const [userIdToken, setUserIdToken] = useState();
    const [status, setStatus] = useState(QueryStatus.PENDING);
    const [error, setError] = useState();
    useEffect(() => {
        const fetchUserIdToken = async () => {
            try {
                const fetchedIdToken = await PayPalPaymentService.getUserIdToken(siteId);
                setStatus(QueryStatus.SUCCESS);
                setUserIdToken(fetchedIdToken);
            }
            catch (error) {
                setError(error);
                setStatus(QueryStatus.ERROR);
            }
        };
        {
            fetchUserIdToken();
        }
    }, [siteId, userId, isCustomerRegistered]);
    return {
        userIdToken,
        status,
        error,
    };
};

export { usePayPalUserIdToken as default };
//# sourceMappingURL=usePayPalUserIdToken.js.map
